/**
 * 레이어 캐시 쿼리 키 — projects-list 의 `projects.queries` 와 shared 의 `gisLayer.queries`·
 * shared 의 `model3d.queries` 가 서로의 캐시를 읽거나 무효화한다. 쿼리 모듈끼리 import 하지 않고 같은 키를
 * 쓰도록 import 없는 리프에 둔다. `projects.queries` 는 `layerDataKey` 를, `gisLayer.queries` 는
 * `layerOptions2dKey` 를 재수출한다(기존 import 경로 유지).
 */

/** 프로젝트 페이지 LayerData 탭 목록 캐시 키(프로젝트 전역). */
export const layerDataKey = (projectId: number) =>
  ["projectLayerData", Number(projectId)] as const;

/**
 * 2D 레이어 옵션 캐시의 프로젝트 접두 키 — 한 프로젝트의 모든 시계열(timeProject) 캐시를 부분일치로
 * 가리킨다. 레이어 rename(프로젝트 전역)의 교차 무효화가 쓴다.
 */
export const layerOptions2dProjectKey = (projectId: number) =>
  ["2dLayerOptions", Number(projectId)] as const;

/** 2D 레이어 옵션 캐시 키 — 프로젝트 접두 키 바로 뒤 칸이 시계열 id 다. */
export const layerOptions2dKey = (projectId: number, timeProjectId: number) =>
  [...layerOptions2dProjectKey(projectId), Number(timeProjectId)] as const;
